// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + {"614":"b90be8a6c10bb5f4a3f2","973":"07f130efa2364e443407"}[chunkId] + ".js";
};